<h2 mat-dialog-title class="dialog-title">
  <span class="badge"><mat-icon>schedule</mat-icon></span>
  <span class="text">
    <span translate="CALLS.EXTEND_RETENTION.TITLE"></span>
    <span class="call-name">{{ data.callName }}</span>
  </span>
  <button mat-icon-button [mat-dialog-close]="null" [attr.aria-label]="'COMMON.CLOSE' | translate"><mat-icon>close</mat-icon></button>
</h2>
<mat-dialog-content>
  <p class="description" translate="CALLS.EXTEND_RETENTION.DESCRIPTION"></p>
  <a class="help-link" [href]="deletionLifecycleHelpUrl" target="_blank" rel="noopener noreferrer">
    <mat-icon class="help-icon">info_outline</mat-icon>
    <span translate="CALLS.EXTEND_RETENTION.HELP_LINK"></span>
  </a>

  <app-retention-timeline
    [view]="timeline"
    (softExtensionInDaysChange)="applySoftExtensionInDays($event)"
    (deletionExtensionInDaysChange)="applyDeletionExtensionInDays($event)"
  ></app-retention-timeline>

  <div class="quick-extend">
    <span class="section-label" translate="CALLS.EXTEND_RETENTION.QUICK_EXTEND"></span>
    <div class="options">
      @for (days of quickExtensionsInDays; track days) {
        <!-- disabledInteractive, so a blocked option still takes the pointer and can show the tooltip
             that says why it is out of reach. The click is refused in the handler. -->
        <button
          mat-stroked-button
          type="button"
          class="option"
          [class.selected]="isQuickExtensionSelected(days)"
          [disabled]="isQuickExtensionBlocked(days)"
          [disabledInteractive]="true"
          [matTooltip]="quickExtensionTooltip(days)"
          (click)="applyQuickExtension(days)"
        >
          {{ quickExtensionLabel(days) }}
        </button>
      }
      @if (hasIncrement) {
        <button mat-stroked-button type="button" class="option maximum" [class.selected]="isIncrementSelected" (click)="applyIncrement()">
          {{ incrementLabel }}
        </button>
      }
      <button mat-stroked-button type="button" class="option reset" [disabled]="!hasChanges" (click)="resetChanges()">
        <mat-icon>history</mat-icon>
        <span translate="CALLS.EXTEND_RETENTION.RESET"></span>
      </button>
    </div>
  </div>

  <div class="date-fields">
    @if (hasSoftDeletion) {
      <div class="field">
        <app-datetime-picker
          [(ngModel)]="softDeletionDate"
          name="soft-deletion-date"
          translationKey="CALLS.EXTEND_RETENTION.SOFT_DELETION_DATE"
          [isDateInvalid]="isSoftDeletionBeyondMaximum"
          errorMessageKey="CALLS.EXTEND_RETENTION.SOFT_BEYOND_MAXIMUM"
          [max]="maximumSoftDate"
        ></app-datetime-picker>
      </div>
    }
    <div class="field">
      <app-datetime-picker
        [(ngModel)]="deletionDate"
        name="deletion-date"
        translationKey="CALLS.EXTEND_RETENTION.DELETION_DATE"
        [isDateInvalid]="isDeletionBeyondMaximum"
        errorMessageKey="CALLS.EXTEND_RETENTION.BEYOND_MAXIMUM"
        [max]="maximumDate"
      ></app-datetime-picker>
    </div>
  </div>

  <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="dialogResult" [disabled]="!canSave" translate="COMMON.SAVE" color="primary"></button>
</mat-dialog-actions>
